
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

import '../../../../node_modules/core-js/modules/es.array.concat.js';
import { memo, useCallback } from 'react';
import classNames from '../../../../node_modules/classnames/index.js';
import Checkbox from '../../FormElements/CheckboxGroup/Checkbox.js';
import { Actions } from '../constants.js';
import { getVisibleAccessors, getDefaultAccessor } from '../helpers.js';
import Cell from './Cell.js';
import DataCells from './DataCells.js';
import { createElement as jsx } from '../../../../node_modules/@emotion/react/dist/emotion-react.browser.esm.js';

var rowClassnames = function rowClassnames(isSelected, callback) {
  return classNames({
    selected: isSelected,
    link: callback
  });
};
var checkboxWrapperClassnames = function checkboxWrapperClassnames(autohide) {
  return classNames("selectable-cell", {
    "autohide-cell": autohide
  });
};
var TableRow = function TableRow(_ref) {
  var rowId = _ref.rowId,
    row = _ref.row,
    columns = _ref.columns,
    windowWidth = _ref.windowWidth,
    windowHeight = _ref.windowHeight,
    isSelected = _ref.isSelected,
    selectable = _ref.selectable,
    autohide = _ref.autohide,
    _ref$disabled = _ref.disabled,
    disabled = _ref$disabled === void 0 ? false : _ref$disabled,
    dispatch = _ref.dispatch,
    onRowClick = _ref.onRowClick,
    onHoveredRowChange = _ref.onHoveredRowChange;
  var accessors = getVisibleAccessors(columns);
  var defaultAccessor = getDefaultAccessor(columns);
  var handleRowClick = useCallback(function () {
    if (disabled) return;
    onRowClick && onRowClick(row);
  }, [row.id, disabled]);
  var handleRowSelection = useCallback(function () {
    if (disabled) return;
    dispatch({
      type: Actions.toggle,
      payload: row
    });
  }, [dispatch, disabled]);
  return jsx("tr", {
    key: "entry-".concat(row.id, "-select"),
    className: rowClassnames(isSelected, Boolean(onRowClick)),
    onMouseEnter: function onMouseEnter() {
      return !disabled && onHoveredRowChange(row);
    },
    onMouseLeave: function onMouseLeave() {
      return !disabled && onHoveredRowChange(null);
    }
  }, selectable && jsx(Cell, {
    key: rowId,
    className: checkboxWrapperClassnames(Boolean(autohide))
  }, jsx(Checkbox, {
    id: rowId,
    key: rowId,
    name: rowId,
    value: rowId,
    checked: isSelected,
    onChange: handleRowSelection,
    disabled: disabled,
    "aria-labelledby": "entry-".concat(row.id, "-").concat(defaultAccessor)
  })), jsx(DataCells, {
    row: row,
    columns: columns,
    accessors: accessors,
    windowHeight: windowHeight,
    windowWidth: windowWidth,
    handleRowClick: handleRowClick
  }));
};
var TableRow$1 = /*#__PURE__*/memo(TableRow);

export { TableRow$1 as default };
//# sourceMappingURL=TableRow.js.map
